import React from "react";
import PlaceholderCard from "../home/card/PlaceholderCard";

type DigestPlaceholderCardProps = {
    useNoItemsText?: boolean;
};

const DigestPlaceholderCard: React.FC<DigestPlaceholderCardProps> = ({ useNoItemsText }) => {
    const finishedText = "You’re all set! There are no action-required digests at the moment. Check out ‘List View’ to see your upcoming schedules, or keep swiping to start over.";
    const noItemsText = "No action-required digests at the moment. Check out ‘List View’ to see your other upcoming schedules."

    return (
        <PlaceholderCard
            message={useNoItemsText
                ? noItemsText
                : finishedText}
        ></PlaceholderCard>
    );
};

export default DigestPlaceholderCard;
